import ky from 'ky';

export default {
  namespace: true,
  state: {
    loadingMapData: false,
    usCountyTopo: {},
    mapData: [],
    // can use terms miles or vehicles
    dataType: 'vehicles',
    infoBoxObj: {},
    dateInfo: {},
    mapTableData: [],
    histogramData: {},
    aggregateDropdownData: [],
    selectedAggregateDropdownData: [],
    chartNames: {
      mpg: 'Average MPG',
      dist_mi: 'Distance By Miles',
      avg_driving_speed: 'Average Driving Speed (MPH)',
      max_driving_speed: 'Maximum Driving Speed (MPH)',
      eng_run_time: 'Engine Run Time (hours)',
      char_a: 'Characteristic Acceleration',
      v_aero: 'Aerodynamic Velocity (MPS)',
      v_ave_moving: 'Average Moving Speed (KPH)',
      fuel_cons_gal: 'Fuel Consumed (gal)',
      hrs_moving: 'Hours Moving',
    },
    noVehicleError: false,

  },
  getters: {
    isDataLoaded: (state) => state.loadingMapData,
    getCountyGeo: (state) => state.usCountyTopo,
    getMapData: (state) => state.mapData,
    getDataType: (state) => state.dataType,
    isMapTypeDistance: (state, getters) => getters.getDataType === 'miles',
    isMapTypeVehicles: (state, getters) => getters.getDataType === 'vehicles',
    getInfoBox: (state) => state.infoBoxObj,
    getMapTableData: (state) => state.mapTableData,
    getDateInfo: (state) => state.dateInfo,
    getHistogramData: (state) => state.histogramData,
    getAggregateDropdownData: (state) => state.aggregateDropdownData,
    getAllChartNames: (state) => state.chartNames,
    getSelectedCharts: (state, getters, rootState) => {
      const hasAggregate = getters.getAggregateDropdownData && getters.getAggregateDropdownData.length >= 1;
      if (rootState.route.query && rootState.route.query.chart !== undefined) {
        const chartRoutes = rootState.route.query.chart;
        const chartArr = typeof chartRoutes === 'string' ? [chartRoutes] : chartRoutes;
        const allCharts = chartArr.map((chart) => ({ name: state.chartNames[chart], id: chart }));
        return allCharts;
      } if (hasAggregate) {
        return ([getters.getAggregateDropdownData[0], getters.getAggregateDropdownData[1]]);
      }
      return [];
    },
    getNoVehicleError: (state) => state.noVehicleError,

  },
  mutations: {
    setLoadingMapData(state, status) {
      state.loadingMapData = status;
    },
    setDataType(state, type) {
      state.dataType = type;
    },
    setMapData(state, mapGeo) {
      const mapGeography = mapGeo.result;
      state.mapTableData = mapGeo.result;
      const mapDataArray = mapGeography.reduce((finalArr, dataObj) => {
        const tempArr = [dataObj.county_fips_code, dataObj.county_name, dataObj.state_abbr, dataObj.vehicle_count, parseInt(dataObj.miles, 10)];
        finalArr.push(tempArr);
        return finalArr;
      }, []);
      state.mapData = mapDataArray;
    },
    setStats(state, info) {
      if (info.vehicle_count === 0) {
        state.noVehicleError = true;
      } else {
        state.noVehicleError = false;
      }
      state.infoBoxObj = {
        hours: parseFloat(info.hours_logged).toLocaleString('en-US'),
        miles: parseFloat(info.miles_traveled).toLocaleString('en-US'),
        mpg: parseFloat(info.average_mpg),
        total: info.vehicle_count.toLocaleString('en-US'),
      };
    },
    setNoVehicleError(state, bool) {
      state.noVehicleError = bool;
    },
    setHistogram(state, data) {
      const sortedData = {
        mpg: {
          title: 'Average MPG',
          measurement: 'MPG',
          range: [],
          count: [],
        },
        dist_mi: {
          title: 'Distance By Miles',
          measurement: 'Miles',
          range: [],
          count: [],
        },
        avg_driving_speed: {
          title: 'Average Driving Speed (MPH)',
          measurement: 'MPH',
          range: [],
          count: [],
        },
        max_driving_speed: {
          title: 'Maximum Driving Speed (MPH)',
          measurement: 'MPH',
          range: [],
          count: [],
        },
        eng_run_time: {
          title: 'Engine Run Time (hours)',
          measurement: 'Hours',
          range: [],
          count: [],
        },
        char_a: {
          title: 'Characteristic Acceleration',
          measurement: 'Meters per second-squared',
          range: [],
          count: [],
        },
        v_aero: {
          title: 'Aerodynamic Velocity (MPS)',
          measurement: 'Meters per second',
          range: [],
          count: [],
        },
        v_ave_moving: {
          title: 'Average Moving Speed (KPH)',
          measurement: 'KPH',
          range: [],
          count: [],
        },
        fuel_cons_gal: {
          title: 'Fuel Consumed (gal)',
          measurement: 'Gallons',
          range: [],
          count: [],
        },
        hrs_moving: {
          title: 'Hours Moving',
          measurement: 'Hours',
          range: [],
          count: [],
        },
      };
      function checkNull(info) {
        return info === null ? 0 : info;
      }
      data.forEach((info) => {
        sortedData.mpg.range.push(info.mpg_bucket_range);
        sortedData.mpg.count.push(checkNull(info.mpg_count));
        sortedData.dist_mi.range.push(info.distance_mi_bucket_range);
        sortedData.dist_mi.count.push(checkNull(info.distance_mi_count));
        sortedData.avg_driving_speed.range.push(info.average_driving_speed_mph_bucket_range);
        sortedData.avg_driving_speed.count.push(checkNull(info.average_driving_speed_mph_count));
        sortedData.max_driving_speed.range.push(info.max_drive_speed_mph_bucket_range);
        sortedData.max_driving_speed.count.push(checkNull(info.max_drive_speed_mph_count));
        sortedData.eng_run_time.range.push(info.eng_run_time_hrs_bucket_range);
        sortedData.eng_run_time.count.push(checkNull(info.eng_run_time_hrs_count));
        sortedData.char_a.range.push(info.char_a_bucket_range);
        sortedData.char_a.count.push(checkNull(info.char_a_count));
        sortedData.v_aero.range.push(info.v_aero_bucket_range);
        sortedData.v_aero.count.push(checkNull(info.v_aero_count));
        sortedData.v_ave_moving.range.push(info.v_ave_moving_kph_bucket_range);
        sortedData.v_ave_moving.count.push(checkNull(info.v_ave_moving_kph_count));
        sortedData.fuel_cons_gal.range.push(info.fuel_cons_gal_bucket_range);
        sortedData.fuel_cons_gal.count.push(checkNull(info.fuel_cons_gal_count));
        sortedData.hrs_moving.range.push(info.hrs_moving_bucket_range);
        sortedData.hrs_moving.count.push(checkNull(info.hrs_moving_count));
      });

      const filteredData = {};
      const aggregateDropdown = [];
      // remove histograms and selectable dropdown data where there is no data present
      Object.keys(sortedData).forEach((key) => {
        const hasValues = sortedData[key].count.filter((point) => point !== 0);
        if (hasValues.length >= 1) {
          filteredData[key] = sortedData[key];
          aggregateDropdown.push({ name: sortedData[key].title, id: key });
        }
      });

      state.histogramData = filteredData;
      state.aggregateDropdownData = aggregateDropdown;
    },
    setDates(state, dateInfo) {
      const dateArray = [];

      const dayObj = {
        Monday: 0,
        Tuesday: 1,
        Wednesday: 2,
        Thursday: 3,
        Friday: 4,
        Saturday: 5,
        Sunday: 6,
      };

      const monthObj = {
        January: 0,
        February: 1,
        March: 2,
        April: 3,
        May: 4,
        June: 5,
        July: 6,
        August: 7,
        September: 8,
        October: 9,
        November: 10,
        December: 11,
      };

      dateInfo.forEach((date) => {
        const weekday = dayObj[date.weekday];
        const month = monthObj[date.month];
        dateArray.push([month, weekday, date.miles]);
      });
      state.dateInfo = dateArray;
    },

  },
  actions: {
    async fetchDashboardData({ commit }, query) {
      commit('setLoadingMapData', true);

      const options = {
        searchParams: query,
        headers: {
          'X-Api-Key': import.meta.env.VUE_APP_NREL_API_KEY,
        },
      };
      try {
        const response = await Promise.all([
          ky.get(`${import.meta.env.VUE_APP_API_URL_ROOT}/v1/map_data.json`, options).json(),
          ky.get(`${import.meta.env.VUE_APP_API_URL_ROOT}/v1/stats.json`, options).json()]);
        commit('setMapData', response[0]);
        // commit('setDateData', response[0].dateInfo);
        commit('setStats', response[1].result.top_level_stats[0]);
        commit('setDates', response[1].result.day_and_month_miles);
        commit('setHistogram', response[1].result.aggregate_stats);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        commit('setLoadingMapData', false);
      } finally {
        commit('setLoadingMapData', false);
      }
    },
  },
};
